// Product page scroll buttons
(function(){
  let scrollTopBtns = document.querySelectorAll('.button[href="#scrollTop"]');
  if (scrollTopBtns.length) {
    scrollTopBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        let top = document.querySelector('#scrollTop').offsetTop;
        window.scroll({
          top: top, 
          left: 0, 
          behavior: 'smooth' 
        });
      });
    });
  }
})();

// Cart priority extra product
(function () {
  $(document).on("click", ".drawer__extra-product-button .js-extra-product-remove", function(e){
    e.preventDefault();
    let itemId = $(this).data('itemId');
        console.log(itemId);
    let removeItemButton =  $(`cart-remove-button[data-item-id="${itemId}"]`);
    removeItemButton.click();
  });
})();

// Product page sticky button on mobile
(function(){
  if (window.matchMedia('(max-width: 767px)').matches) {
    // var stickyBtn = document.querySelector('#stickyBtn');

    // window.addEventListener('scroll', function(){
    //   var anyIsInViewport = false;
    //   var ctaBtns = document.querySelectorAll('.product-form__submit, .button[href="#scrollTop"]:not(.scrolling-btn--sticky)');
    //   ctaBtns.forEach(btn => {
    //     var elementTop = btn.offsetTop;
    //     var elementBottom = elementTop + btn.offsetHeight ;
    //     var viewportTop = window.scrollY;
    //     var viewportBottom = viewportTop + window.innerHeight;
    //     if (elementBottom > viewportTop && elementTop < viewportBottom) {
    //       anyIsInViewport = true;
    //     }
    //   });

    //   if (anyIsInViewport) {
    //     stickyBtn.classList.add('hidden');
    //   } else {
    //     stickyBtn.classList.remove('hidden');
    //   }
    // });
    var stickyBtn = $('#stickyBtn');

    $(window).scroll(function(){
      var anyIsInViewport = false;
      var ctaBtns = $('.product-form__submit, .button[href="#scrollTop"]:not(.scrolling-btn--sticky)');
      ctaBtns.each(function(){
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height() + 200;
        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          anyIsInViewport = true;
        }
      });

      if (anyIsInViewport) {
        stickyBtn.addClass('hidden');
      } else {
        stickyBtn.removeClass('hidden');
      }
    });
  }
})();

// Product page default option
// (function(){
//   document.querySelector('.bundle-option-input input:checked').removeAttribute('checked');
//   document.querySelector('.bundle-option-input input:nth-of-type(2)').setAttribute('checked', '');
//   document.querySelector('variant-radios').onVariantChange(false);
// })();

// Product page Bundle&Save section
// (function(){
//   let bundleOptionSection = document.querySelector('.bundle-option-input');
//   if (bundleOptionSection) {
//      bundleOptionSection.querySelector('.form__label').addEventListener('click', function(e) {
//        bundleOptionSection.classList.toggle('opened');
//      });
//   }
// })();

// Product page video slides
(function () {
  // Slider
  let desktopSlidesPerRow = 4;
  if ($('.product__video-slides-slider').data('desktopSlidesPerRow')) {
    desktopSlidesPerRow = $('.product__video-slides-slider').data('desktopSlidesPerRow');
  }
  if($('.product__video-slides-slider').length>0){
        $('.product__video-slides-slider').slick({
    infinite: true,
    slidesToShow: desktopSlidesPerRow,
    autoplay: false,
    autoplaySpeed: 2000,
    prevArrow: `<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,
    nextArrow: `<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  }


  // Video click
  $('.product__video-slides-slider video').click(function(e){
    if (e.detail == 2) {
      if (this.requestFullscreen) {
        this.requestFullscreen();
      }
    } else {
      if (!document.fullscreenElement) {
        if (this.paused) {
          this.play();
          $(this).next('.product__video-slides-play-icon').addClass('hidden');
          $(this).prev('.product__video-slides-fullscreen-icon').removeClass('hidden');
        } else {
          this.pause();
          $(this).next('.product__video-slides-play-icon').removeClass('hidden');
          $(this).prev('.product__video-slides-fullscreen-icon').addClass('hidden');
        }
      }
    }
  });

  // full screen mode handle
  $('.product__video-slides-slider video').on('fullscreenchange', function(e){
    if (this.paused) {
      $(this).next('.product__video-slides-play-icon').removeClass('hidden');
      $(this).prev('.product__video-slides-fullscreen-icon').addClass('hidden');
    } else {
      $(this).next('.product__video-slides-play-icon').addClass('hidden');
      $(this).prev('.product__video-slides-fullscreen-icon').removeClass('hidden');
    }
  });

  // full screen button
  $('.product__video-slides-fullscreen-icon').click(function(e){
    let targetVideo = $(this).next('video');
    if (targetVideo[0] && targetVideo[0].requestFullscreen) {
      targetVideo[0].requestFullscreen();
    }
  });
  
})();

// Before-after slider
(function () {
  const slider = document.querySelector('.product-before-after-slider');

  if (!slider) {
    return;
  }

  const before = document.getElementById('before-image');
  const beforeImage = before.querySelector('img');
  const resizer = document.getElementById('resizer');

  let active = false;

  //Sort overflow out for Overlay Image
  document.addEventListener("DOMContentLoaded", function () {
    let width = slider.offsetWidth;
    beforeImage.style.width = width + 'px';
    before.style.width = width/2 + 'px';
    slider.style.opacity = 1;
  });

  //Adjust width of image on resize
  window.addEventListener('resize', function () {
    let width = slider.offsetWidth;
    beforeImage.style.width = width + 'px';
  })

  resizer.addEventListener('mousedown',function () {
    active = true;
    resizer.classList.add('resize');
  });

  document.body.addEventListener('mouseup',function () {
    active = false;
   resizer.classList.remove('resize');
  });

  document.body.addEventListener('mouseleave', function () {
    active = false;
    resizer.classList.remove('resize');
  });

  document.body.addEventListener('mousemove',function (e) {
    if (!active) return;

    let x = e.pageX;

    x -= slider.getBoundingClientRect().left;

    slideIt(x);
    pauseEvent(e);
  });

  resizer.addEventListener('touchstart', function () {
    active = true;
    resizer.classList.add('resize');
  });

  document.body.addEventListener('touchend',function () {
    active = false;
    resizer.classList.remove('resize');
  });

  document.body.addEventListener('touchcancel',function () {
    active = false;
    resizer.classList.remove('resize');
  });

  //calculation for dragging on touch devices
  document.body.addEventListener('touchmove',function(e){
    if (!active) return;

    let x;
    let i;

    for (i=0; i < e.changedTouches.length; i++) {
      x = e.changedTouches[i].pageX;
    }

    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });

  function slideIt (x) {
    let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
    before.style.width = transform+"px";
    resizer.style.left = transform-0+"px";
  }

  //stop divs being selected.
  function pauseEvent (e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    e.cancelBubble=true;
    e.returnValue=false;
    return false;
  }
})();
// tabs
(function(){
  let tabLinks = document.querySelectorAll('.tab-link');
  let tabs = document.querySelectorAll('.tab');
  for (const link of tabLinks) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      if (link.classList.contains('active')) return;

      const tabIDSelector = link.getAttribute('href');

      for (const tab of tabs) {
        tab.style.display = 'none';
      }
      for (const l of tabLinks) {
        l.classList.remove('active');
      }

      document.querySelector(tabIDSelector).style.display = 'block';
      e.currentTarget.classList.add('active');
    });
  }
})();

